import React, {useEffect, useState} from "react";
import "./microbial_sex_loops"

import styles from "./mia_interface_style.module.css"

import * as Data from "./get_section_content"
import {GetAssetID, GetDescription, GetNext, GetProcessID} from "./get_section_content";

export default function MiaFrame({section, currentAudio, buttonPressed}) {

    function startProcess(id, title) {
        console.log(`Clicked button: ${title} (${id})`)
        buttonPressed(id, title);
    }

    function reset() {
        console.log("reset");
        buttonPressed(Data.HOME, Data.HOME);
    }

    return (
        <div className={styles.miaFrame}>
            <div className={styles.heading}>paths through the microbial sex loops</div>

            <br/><br/>
            
            <SectionText process_id={GetProcessID(section)} title={section} description={GetDescription(section)}/>

            <br/>

            <div className={styles.buttonContainer}
                 style={{textAlign: section === Data.HOME ? "center" : "left"}}>
                
                <button
                    className={styles.button}
                    id="resetBtn"
                    onClick={reset}
                    style={{display: section === Data.HOME ? "none" : "inline"}}> Reset
                </button>

                {Data.AssetIDs.map(id => (
                    <ProcessButton id={id} key={id} clickHandler={startProcess} text={Data.GetTitle(id)}/>
                ))}
            </div>

        </div>)

    function SectionText({process_id, title, description}) {
        // process id = shorthand eg. ca = cannibalism
        return (<>
            <div style={{textAlign: "left"}}>
                <Title id={process_id} title={title}/>
                <Description id={process_id} text={description}/>
            </div>
        </>)

        function Title({id, title}) {
            if (title === Data.HOME) return null;
            else return (
                <div id={id + "H2"}>
                    <h2 className={styles.title}>{title}</h2>
                </div>
            )
        }

        function Description({id, text}) {
            return (<div id={id + "P"}>
                <div className={styles.description}>{text}</div>
            </div>)
        }
    }

    function ProcessButton({id, text, clickHandler}) {
        const [isVisible, setIsVisible] = useState(true);


        useEffect(() => {
            setIsVisible(false);

            const next = GetNext(GetAssetID(section));

            let timeoutID;
            if (currentAudio) {
                if (next.includes(id)) {
                    if (section === Data.HOME) {
                        setIsVisible(true);
                    } else {
                        // console.log(`Setting timeout for ${currentAudio.duration}`)
                        timeoutID = setTimeout(() => {
                            // console.log(`Setting ${text} to visible`);
                            setIsVisible(true)
                        }, currentAudio.duration * 1000)
                    }
                }

            } else {
                setIsVisible(true);
            }
            return () => {
                if (timeoutID) {
                    // console.log(`Clearing timeout for ${text}`)
                    clearTimeout(timeoutID);
                }
            }
        }, [section]);

        if (isVisible)
            return <button
                className={styles.button}
                id={id}
                onClick={() => clickHandler(id, text)}>
                {text}
            </button>
        else
            return null;
    }
}
